import React, { useEffect, useState } from "react";
import Markdown from "../common/markdown";
import "./air.css";

const ImplementationPopupImp = ({ popupDescription }) => {
  const [currentPopup, setCurrentPopup] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [description, setDescription] = useState("");

  useEffect(() => {
    console.log("Popup content:", popupDescription);
    setDescription(popupDescription);
  }, [popupDescription]);

  const handlePopup = (id) => {
    setCurrentPopup(description[id]);
    console.log("Opening:", id);
    setShowPopup(true);
  };

  return (
    <>
      <div className="implementation-popup-container">
        {description &&
          description.map((item, index) => {
            return (
              <div className="img-container">
                <img
                  src={item.imageURL}
                  alt="{item.imageAltText}"
                  onClick={handlePopup.bind(this, index)}
                />
              </div>
            );
          })}
      </div>

      {/* Overlay */}
      {showPopup && currentPopup && (
        <div
          className="implementation-popup overlay-panel-container"
          onClick={() => setShowPopup(false)}
        >
          <div className="overlay-panel" onClick={(e) => e.stopPropagation()}>
            {/* Prevents closing when clicking inside the panel */}

            <div className="header-section">
              <img
                src={currentPopup.popupIconURL}
                alt={currentPopup.popupIconAltText}
                className="icon"
              />
              <span className="header-span">
                <h2>{currentPopup.popupTitle}</h2>
                <h3>{currentPopup.popupSubtitle}</h3>
              </span>
            </div>
            <div className="body">
              <Markdown children={currentPopup.popupBody} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ImplementationPopupImp;
